module.exports = __webpack_public_path__ + "static/media/car-default.77509e7f.jpg";